import { IFInitWalletRechargeCryptoRsp } from '@/api/apiRsp/IFWalletRsp';
import CurrencyComponent from '@/components/currencyComponent';
import ButtonUI from '@/componentsUI/Button';
import InputUI from '@/componentsUI/Input';
import { useTranslationPlus } from '@/Core/i18n/useTranslationPlus';
import { AmountDivisorConversion, AmountMultiplierConversion, dealAmountAnyValid, numberFixed } from '@/Core/utils/currencyDealCenter';
import classNames from 'classnames';
import React from 'react';
import { getLegacyDepositBonus } from "../../recharge/flat/compoments/depositAmount/depositBonus";

export interface InputAmountProps {
  readOnly?: boolean;
  value?: any;
  data?: IFInitWalletRechargeCryptoRsp;
  onChange?: any;
  placeholder?: any;
  currencyType?: any;

  dataRuleItems?: any;
  dataLimit?: any;
}
//IFInitWalletRechargeCryptoRsp

const InputAmount = (props: InputAmountProps) => {
  const { readOnly, value = {}, data, onChange, placeholder, currencyType } = props;
  
  const prefixCls = 'input-amount';
  const { t } = useTranslationPlus('Wallet');
  const bonus = getLegacyDepositBonus(data, Number(value?.value), currencyType ?? value?.currencyType).bonus;
  const iValue = bonus ? AmountDivisorConversion(bonus.amount, { currencyType: bonus.currencyType }) : 0;
  const selectedIndex = (data?.custGears?.length ? data.custGears.map((item) => item.gear) : data?.gears)
    ?.findIndex((gear) => value?.value !== undefined &&
      Number(value.value) === AmountDivisorConversion(gear, { currencyType: currencyType ?? value?.currencyType })) ?? -1;

  const handleChange = (newValue) => {
    const am = Number(newValue?.value);
    if (isNaN(am)) return;
    let va;
    if (data?.decide == 1) {
      //定额
      va = newValue?.value;
    } else {
      //非定额
      const amax =
        AmountDivisorConversion(data?.max, {
          currencyType: currencyType ?? value?.currencyType,
        }) || 0;
      if (am > amax) {
        va = amax;
      } else {
        va = am;
      }
    }
    onChange && onChange({ ...newValue, value: va });
  };
  const onBlur = () => {
    if (readOnly) {
      return;
    }
    if (value?.value === undefined || value?.value === '') {
      handleChange({ ...value, select: -1 });
      return;
    } else {
      let index;
      const num = AmountMultiplierConversion(value?.value, {
        currencyType: currencyType ?? value?.currencyType,
      });
      if (data?.rebateRuleItems?.length > 0) {
        index = data?.custGears?.findIndex((v) => {
          if (v?.gear == `${num}`) {
            return true;
          }
        });
      } else {
        index = data?.gears?.findIndex((v) => {
          if (v == `${num}`) {
            return true;
          }
        });
      }
      handleChange({ ...value, value: value?.value, select: index });
    }
  };
  return (
    <div className={prefixCls}>
      {data?.decide == 2 && (
        <InputUI
          onBlur={onBlur}
          value={value?.value}
          placeholder={placeholder}
          onChange={(v) => {
            handleChange({ ...value, value: v });
          }}
          readOnly={readOnly}
          maxLength={10}
          prefix={<CurrencyComponent showUnit={false} currencyType={currencyType ?? value?.currencyType} />}
          suffix={
            iValue &&
            value?.value && (
              <div className={`${prefixCls}-suffix`}>
                <label>{t('Extra')}:</label>
                <span>+ {numberFixed(iValue,2)}</span>
              </div>
            )
          }
        ></InputUI>
      )}
      <div className={classNames(`${prefixCls}-row`, data?.decide == 2 && 'pixFDing')}>
        {data?.custGears?.length > 0
          ? data?.custGears?.map((item, i) => {
              return (
                <div className={classNames('btn', selectedIndex === i ? 'btnChecked' : '')} key={i.toString()}>
                  <ButtonUI
                    onClick={() => {
                      handleChange({
                        ...value,
                        value: dealAmountAnyValid(item?.gear, 0, {
                          currencyType: currencyType ?? value?.currencyType,
                        }),
                        select: i,
                      });
                    }}
                  >
                    {dealAmountAnyValid(item?.gear, 0, {
                      currencyType: currencyType ?? value?.currencyType,
                    })}
                  </ButtonUI>
                  {
                    //有充值得定额，展示角标
                    item?.rebateRate && <label key={i + 100} className={`Ratio`}>
                      {item?.rebateRate}%
                    </label>
                  }
                </div>
              );
            })
          : data?.gears?.map((item, i) => {
              //无角标
              return (
                <div className={classNames('btn', selectedIndex === i ? 'btnChecked' : '')} key={i}>
                  <ButtonUI
                    key={item}
                    onClick={() => {
                      handleChange({
                        ...value,
                        value: dealAmountAnyValid(item, 0, {
                          currencyType: currencyType ?? value?.currencyType,
                        }),
                        select: i,
                      });
                    }}
                  >
                    {dealAmountAnyValid(item, 0, {
                      currencyType: currencyType ?? value?.currencyType,
                    })}
                  </ButtonUI>
                </div>
              );
            })}
      </div>
    </div>
  );
};

export default InputAmount;
